module.exports = __webpack_public_path__ + "img/w39.322bb2e5.svg";